<h2 mat-dialog-title>{{ 'activity_search.panel_title' | translate }}</h2>
<mat-dialog-content>
    <app-activity-selection-actions
        [selectedCount]="selectedActivityCount"
        (clearSelection)="clearSelection()"
        (validateSelection)="close()">
    </app-activity-selection-actions>

    <app-mathia-lessons-search-filter
        (selectionChange)="onSelectionChange($event)">
    </app-mathia-lessons-search-filter>

    @if (isLoading) {
        <mat-spinner diameter="32"></mat-spinner>
    } @else {
        <div class="mathia-activity-search-dialog__results">
            @for (activity of activities; track activity.id) {
                <button
                    mat-button
                    type="button"
                    [class.selected]="isSelected(activity.id)"
                    (click)="toggleActivity(activity.id)">
                    {{ activity.get('title') || activity.get('metadatas')?.title || activity.id }}
                </button>
            }
        </div>
    }
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button type="button" mat-dialog-close>{{ 'generic.cancel' | translate }}</button>
</mat-dialog-actions>
